import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=1b9e261e&scoped=true&lang=html&"
import script from "./accept.vue?vue&type=script&lang=js&"
export * from "./accept.vue?vue&type=script&lang=js&"
import style0 from "./accept.vue?vue&type=style&index=0&id=1b9e261e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e261e",
  null
  
)

component.options.__file = "accept.vue"
export default component.exports